var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      !_vm.isProfileFilled
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "error",
                        dense: ""
                      }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "white--text fw-bold underline",
                          attrs: {
                            to: {
                              name: "profile_info"
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.empty_profile_text) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-row",
            [
              _c("domain-transfer"),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-header", [_vm._v(" Domain Transfer FAQ ")]),
                      _c(
                        "gg-card-text",
                        [
                          _c(
                            "v-expansion-panels",
                            [
                              _c(
                                "v-expansion-panel",
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      "Question #1 Accepted Domains & Pricing"
                                    )
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [_c("first-question")],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel",
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      "Question #2 Domain Transfer Instructions"
                                    )
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [_c("second-question")],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel",
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      "Question #3 New ICANN Rules For Domain Names Starting January 1, 2014"
                                    )
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [_c("third-question")],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }